import React from "react";
import Footer from "../layout/Footer";
import Intro from "../components/About/Intro";
import Mission from "../components/About/Mission";
import Research from "../components/About/Research";
import Partners from "../components/About/Partners";

const About = () => {
  return (
    <div>
    <div className="w-full flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-[#353535]">
    <div className="w-full space-y-[60px] lg:space-y-[90px]">
          <Intro/>
          <Mission/>
          <Research/>
          <Partners/>
      </div>
      </div>
      <Footer/>
    </div>
  );
};

export default About;
